import React from 'react';

import Button from 'antd/es/button';
import PhoneOutlined from '@ant-design/icons/es/icons/PhoneOutlined';

import loginStyles from '../Styles/publicRoutes/login.module.less';
import { LoginTestimonialSidepanel } from './LoginTestimonialSidepanel';
import { classNames } from '../Utils/pureHelpers';
import { BEAM_SALES_PHONE_NUMBER, AERIAL_SALES_PHONE_NUMBER, SUPPORT_PHONE_NUMBER } from '../Constants/Constant';
import { ATTENTIVE_AI, BEAM_AI, PRIVACY_POLICY, TERMS_OF_USE } from '../Constants/Urls';
import { isBeamUser } from '../Utils/usersTypes';

/**
 * Common layout for login & signup pages including sidepanel & footer
 * @param {*} props
 */

const MainLoginLayout = (props: $TSFixMe) => {
  const { loginpageContainer, loginpageArea, loginpage, loginFooter, callButton, antIconPhone } = loginStyles;
  const phoneNumber = props?.isSignupPage
    ? isBeamUser()
      ? BEAM_SALES_PHONE_NUMBER
      : AERIAL_SALES_PHONE_NUMBER
    : SUPPORT_PHONE_NUMBER;

  return (
    <div className={classNames(props?.className, loginpageContainer)}>
      <LoginTestimonialSidepanel isLoadingLoginLogo={props?.isLoadingLoginLogo} logo={props?.logo} />

      <div className={loginpageArea}>
        <div className={loginpage}>{props?.children}</div>

        <div className={loginFooter}>
          <p>
            &copy;{' '}
            <a href={isBeamUser() ? BEAM_AI : ATTENTIVE_AI} target='_blank'>
              Attentive Inc.
            </a>{' '}
            |{' '}
            <a href={TERMS_OF_USE} target='_blank'>
              Terms of Use
            </a>{' '}
            |{' '}
            <a href={PRIVACY_POLICY} target='_blank'>
              Privacy Policy
            </a>
          </p>
        </div>
      </div>

      <a href={`tel:${phoneNumber}`}>
        <Button className={callButton} icon={<PhoneOutlined className={antIconPhone} />} size='large'>
          {phoneNumber}
        </Button>
      </a>
    </div>
  );
};

export default MainLoginLayout;
